import { FeatureFlagsState } from '@/stores/FeatureFlags/state'
import { FeatureFlag } from '@/stores/FeatureFlags/types'

export const SET_FEATURE_FLAGS = 'SET - Feature Flags'

export default {
  [SET_FEATURE_FLAGS](state: FeatureFlagsState, payload: Record<FeatureFlag, boolean>) {
    state.featureFlags = { ...payload }
    state.loaded = true
  },
}
